module.exports = __webpack_public_path__ + "static/media/bars.e9e603b5.svg";